<template>
  <ul
    id="fcbDefault"
    ref="chipsBar"
    :class="['ob1-filter-chips-bar', {'multi-line' : !oneLine}]"
    data-ob1-component="FilterChipsBar"
    aria-label="Liste des filtres pour restreindre la liste de résultats">
    <li
      v-for="item in visibleMenu"
      :key="`filter-chip-${item.id}`"
      class="filter-item ob1-filterchip">
      <input
        :id="`filter-chip-${item.id}`"
        :checked="list.includes(`filter-chip-${item.id}`)"
        class="ob1-filterchip-input sr-only"
        type="checkbox"
        :value="`filter-chip-${item.id}`"
        @change="setList">
      <label
        :for="`filter-chip-${item.id}`"
        class="ob1-filterchip-label"
        :data-title="item.label"
        v-text="item.label" />
    </li>
    <li
      v-if="oneLine"
      id="btnMore"
      ref="btnMore"
      :class="['ob1-filterchip', { 'ob1-filterchip-selected': numberSelected > 0 }]">
      <button
        class="ob1-filterchip-label ob1-filter-chips-bar-btn"
        type="button"
        :aria-label="moreButtonAriaLabel"
        :data-title="moreButtonLabel"
        @click="onMoreButtonClicked"
        v-text="`${moreButtonLabel}  ${numberSelected ? '(' + numberSelected + ')' : ''}`" />
    </li>
  </ul>
</template>
<script>
export default {
  name: 'ChipsBar',
  props: {
    // the elements of the items list must contain an id and a label
    items: {
      type: Array,
      required: true
    },
    // list of checked items returned by the wrapper element
    checkedItemsList: {
      type: Array,
      default: () => []
    },
    oneLine: {
      type: Boolean,
      default: false
    },
    moreButtonLabel: {
      type: String,
      default: 'Plus de filtres'
    },
    moreButtonAriaLabel: {
      type: String,
      default: 'Plus de filtres'
    }
  },
  data () {
    return {
      // list used to set the attribute "checked"
      list: [],
      btnMoreW: 0,
      itemsFilters: [],
      breakWidths: [],
      menuToolbarWidth: 0,
      nbVisible: this.items.length
    }
  },
  computed: {
    visibleMenu () {
      return this.items.slice(0, this.nbVisible)
    },
    numberSelected () {
      return this.items.slice(this.nbVisible)
        .filter(event => this.list.includes(`filter-chip-${event.id}`)).length
    }
  },
  // watcher necessary to update the checked attributes correctly
  watch: {
    checkedItemsList: function (val) {
      this.list = val
    }
  },
  mounted () {
    this.list = this.checkedItemsList
    // check on resize
    if (this.oneLine) {
      window.addEventListener('resize', this.check)
      // first check
      this.$nextTick(this.check)
    }
  },
  methods: {
    // check call when resize
    check () {
      // initial state
      if (this.$refs.chipsBar && this.oneLine) {
        this.itemsFilters = [...this.$refs.chipsBar.querySelectorAll('li')]
        // transform itemsFilters in real array for forEach
        const btnMoreWidth = this.$refs.btnMore?.getBoundingClientRect().width || 0
        this.btnMoreW = this.btnMoreW > 0 ? this.btnMoreW : btnMoreWidth
        // the aim of this condition is to have the most possible breakwidth values
        // to avoid blinking items on resize
        if (this.breakWidths.length < this.itemsFilters.length) {
          this.breakWidths = this.itemsFilters.map(item => item.offsetWidth + 6)
        }
        // the space available for the chips to be displayed is all the chipsBar minus the potential moreButton width
        this.filterBarWidth = this.$refs.chipsBar.getBoundingClientRect().width - btnMoreWidth
        let nbToShow = 0
        let menuLength = 0
        // x is set to 1 only if the more button is not necessary to show
        // when there is place to display the last item instead of the more button
        let x = 0
        for (let i = 0; i < this.breakWidths.length; i++) {
          if (i === this.items.length - 1 && menuLength + this.btnMoreW < this.filterBarWidth + btnMoreWidth) {
            x = 1
          }
          menuLength += this.breakWidths[i]
          if (menuLength > this.filterBarWidth) {
            break
          }
          nbToShow = i + 1
        }
        this.nbVisible = nbToShow + x
        // only display the more button if not every items are displayed
        this.$refs.btnMore.style.display = this.nbVisible >= this.items.length ? 'none' : ''
      }
    },
    onMoreButtonClicked () {
      this.$emit('chipsbar-more-button-clicked')
    },
    setList (event) {
      const idIndex = this.list.indexOf(event.target.id)
      idIndex === -1 ? this.list.push(event.target.id) : this.list.splice(idIndex, 1)
      this.$emit('chipsbar-list-updated', this.list)
    }
  }
}
</script>
<style scoped>
.multi-line {
  max-height: none;
}
</style>
